import clsx from 'clsx'
import Icon from 'snippets/icon/icon'
import { getSizeType } from '../helpers/universalSizeMapping'
import { sizeUnitLabel } from 'helpers/size-units.mjs'
import { RANGE_INDICATOR, isPriceFilterField, isToggleFilterField, getToggleFilterConfig, splitFilterPair, formatFilterDisplayValue } from './FilterUtils'

export function FilterSelected({ activeFilters, onRemove, onClear, variant = 'default' }) {
  if (!activeFilters || activeFilters.size === 0) return null

  const isToolbar = variant === 'toolbar'

  const clearButton = (
    <btn
      className={clsx(
        'btn btn-sm btn-outline-black shrink-0',
        isToolbar && 'relative z-10 bg-primary-white pl-2'
      )}
      onClick={onClear}
    >
      Clear all
    </btn>
  )

  const chips = []
  const seenLabels = new Set()
  for (const filter of activeFilters) {
    const { field: handle, value } = splitFilterPair(filter)
    const label = getFilterLabel(handle, value)
    const seenKey = `${handle}:${String(label).toLowerCase()}`
    if (seenLabels.has(seenKey)) continue
    seenLabels.add(seenKey)
    chips.push(
      <btn
        class="shrink-0 btn btn-sm btn-solid-white !bg-neutrals-base hover:opacity-60"
        onClick={() => onRemove(filter)}
      >
        {label}{' '}
        <span>
          <Icon id="close" />
        </span>
      </btn>
    )
  }

  return (
    <div
      className={clsx(
        'flex min-w-0 w-full items-center gap-2',
        isToolbar ? 'flex-nowrap' : 'py-4 pl-4 border-t border-neutrals-light-grey'
      )}
    >
      {!isToolbar && clearButton}
      <div
        className={clsx(
          'flex min-w-0 items-center gap-2 overflow-x-auto no-scrollbar',
          isToolbar ? 'flex-1' : 'min-w-0 flex-1 pr-4'
        )}
      >
        {chips}
      </div>
      {isToolbar && clearButton}
    </div>
  )
}

const getFilterLabel = (handle, value) => {
  const sizeType = getSizeType(handle)
  if (sizeType) {
    return `${sizeUnitLabel(sizeType)} ${value}`
  }

  if (value.includes(RANGE_INDICATOR)) {
    const [min, max] = value.split(RANGE_INDICATOR)
    const prefix = isPriceFilterField(handle) ? '$' : ''
    return `${prefix}${min} - ${prefix}${max}`
  }

  if (isToggleFilterField(handle)) {
    return getToggleFilterConfig(handle)?.label || value
  }
  return formatFilterDisplayValue(value)
}
